import { useState } from 'react'
import { LazyLoadImage } from "react-lazy-load-image-component";
import emojimoda from '../../assets/images/icon/moda👠.png'
import emojiregalos from '../../assets/images/icon/regalos🎁.png'
import emojipetshop from '../../assets/images/icon/petshop🐶.png'
import emojielectronica from '../../assets/images/icon/electronica🖥.png'
import emojilicoreria from '../../assets/images/icon/licoreria🍾.png'
import webmoda from '../../assets/images/assets/moda.png'
import webregalos from '../../assets/images/assets/regalos.png'
import webpetshop from '../../assets/images/assets/petshop.png'
import webelectronica from '../../assets/images/assets/electronica.png'
import weblicoreria from '../../assets/images/assets/licoreria.png'
import Arrow from './components/Arrow'

const webExamples = [
    {
        id: 1,
        name: 'Moda',
        src_emoji: emojimoda,
        src_web: webmoda,
        url: 'https://moda.powerbizz.com'
    },
    {
        id: 2,
        name: 'Regalos',
        src_emoji: emojiregalos,
        src_web: webregalos,
        url: 'https://regalos.powerbizz.com'
    },
    {
        id: 3,
        name: 'Petshop',
        src_emoji: emojipetshop,
        src_web: webpetshop,
        url: 'https://petshop.powerbizz.com'
    },
    {
        id: 4,
        name: 'Electrónica',
        src_emoji: emojielectronica,
        src_web: webelectronica,
        url: 'https://electronicos.powerbizz.com'
    },
    {
        id: 5,
        name: 'Licorería',
        src_emoji: emojilicoreria,
        src_web: weblicoreria,
        url: 'https://licoreria.powerbizz.com'
    },
]

function WebExample() {
    const [exampleSelected, setExampleSelected] = useState(webExamples[0])

    const changeWebExample = (el) => {
        setExampleSelected(el)
    }

    return (
        <div className='feature-section-five'>
            <div className='content-section'>
                <h2 className='title'>Algunos ejemplos</h2>
                <div className='content'>
                    <ul>
                        {
                            webExamples.map(el =>
                                <li className={`${el.id !== 1 && `border-t-2`}`} key={el.id + '_' + el.name}>
                                    <button onClick={() => changeWebExample(el)}>
                                        <div>
                                            <p>{el.name}</p>
                                            <LazyLoadImage src={el.src_emoji} alt={'emoji_' + el.name} />
                                        </div>
                                        {/* <Arrow color={'#8163FF'} /> */}
                                        {Arrow(exampleSelected.id == el.id ? '#8163FF' : '#CACACA')}
                                    </button>
                                </li>
                            )
                        }
                    </ul>
                    <div className='content-img'>
                        <LazyLoadImage src={exampleSelected.src_web} alt={'web_' + exampleSelected.name} />
                        <div>
                            <p >Mire este ejemplo en detalle</p>
                            <a href={exampleSelected.url} target='_blank'>Aquí</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WebExample